import { render } from "./EmployeeSalary.vue?vue&type=template&id=c7f3e5e2"
import script from "./EmployeeSalary.vue?vue&type=script&lang=js"
export * from "./EmployeeSalary.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp3\\htdocs\\a\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__